// Shared form styling utilities
const BRAND_COLOR = "#3f4e8c";
const UNDERLINE_COLOR = "#BFA2CA";

// Base underline styles with brand color
const baseUnderlineStyles = {
  borderBottomColor: `${UNDERLINE_COLOR} !important`,
  "&:hover": {
    borderBottomColor: `${UNDERLINE_COLOR} !important`,
  },
  "&:before": {
    borderBottomColor: `${UNDERLINE_COLOR} !important`,
    borderBottomWidth: "1px !important",
  },
  "&:after": {
    borderBottomColor: `${UNDERLINE_COLOR} !important`,
    borderBottomWidth: "2px !important",
  },
};

// Base label styles
const baseLabelStyles = {
  "& .MuiInputLabel-root": {
    color: BRAND_COLOR,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: BRAND_COLOR,
  },
  // Icon styles
  "& .MuiSvgIcon-root": {
    color: UNDERLINE_COLOR,
  },
  "& .MuiIconButton-root": {
    color: UNDERLINE_COLOR,
  },
};

// Standard TextField styles
export const inputStyles = {
  mb: 2,
  ...baseLabelStyles,
  "& .MuiInput-underline": {
    borderBottomColor: UNDERLINE_COLOR,
    "&:hover": {
      borderBottomColor: UNDERLINE_COLOR,
    },
    "&.Mui-focused": {
      borderBottomColor: UNDERLINE_COLOR,
    },
    "&.Mui-focused:after": {
      borderBottomColor: UNDERLINE_COLOR,
      borderBottomWidth: 2,
    },
    "&:before": {
      borderBottomColor: UNDERLINE_COLOR,
    },
  },
  "& .MuiInputBase-input": {
    color: BRAND_COLOR,
  },
};

// Select component styles
export const selectStyles = {
  ...baseLabelStyles,
  "& .MuiInput-underline": {
    ...baseUnderlineStyles,
    borderBottomWidth: "1px !important",
  },
  "&.MuiInputBase-root": {
    borderBottomColor: `${UNDERLINE_COLOR} !important`,
    "&:before": {
      borderBottomColor: `${UNDERLINE_COLOR} !important`,
    },
    "&:after": {
      borderBottom: `2px solid ${UNDERLINE_COLOR} !important`,
    },
  },
  "& .MuiInputBase-input": {
    color: BRAND_COLOR,
  },
};

// DatePicker styles
export const datePickerTextFieldStyles = {
  ...baseLabelStyles,
  "& .MuiInput-underline": {
    ...baseUnderlineStyles,
    borderBottomWidth: "1px !important",
  },
  "& .MuiPickersInputBase-root": {
    borderBottomColor: `${UNDERLINE_COLOR} !important`,
    color: BRAND_COLOR,
    "&:before": {
      borderBottomColor: `${UNDERLINE_COLOR} !important`,
    },
    "&:after": {
      borderBottom: `2px solid ${UNDERLINE_COLOR} !important`,
    },
  },
  "&.MuiPickersInputBase-root::after": {
    borderBottomColor: `${UNDERLINE_COLOR} !important`,
    borderBottom: `2px solid ${UNDERLINE_COLOR} !important`,
  },
  "& .MuiInputBase-input": {
    color: BRAND_COLOR,
  },
  // DatePicker specific text and icon styles
  "& .MuiInputBase-root": {
    color: BRAND_COLOR,
  },
  "& .MuiInputBase-root input": {
    color: BRAND_COLOR,
  },
  "& .MuiPickersCalendarHeader-root": {
    "& .MuiSvgIcon-root": {
      color: UNDERLINE_COLOR,
    },
  },
  "& .MuiPickersDay-root": {
    color: BRAND_COLOR,
  },
  "& .MuiPickersDay-root.Mui-selected": {
    backgroundColor: UNDERLINE_COLOR,
  },
};

// FormControl styles for Select wrapper
export const formControlStyles = {
  mb: 2,
  "& .MuiInputLabel-root": {
    color: BRAND_COLOR,
    fontSize: "1rem",
    "&.Mui-focused": {
      color: BRAND_COLOR,
    },
  },
  // Select dropdown icon
  "& .MuiSelect-icon": {
    color: UNDERLINE_COLOR,
  },
  "& .MuiSvgIcon-root": {
    color: UNDERLINE_COLOR,
  },
};
